export default __webpack_public_path__ + "static/media/TozziniFreire.c3f92c0e.png";